import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { withRouter } from 'react-router-dom';

import {
  DataBlocks,
  I18n,
  TextInput,
  Button,
} from 'components';

import { formatLogin } from 'utils/formatString';

import PinPuk from '../PinPuk';

import styles from './styles.pcss';
import { getNicknameInputError, normalizeName, validateNickname } from '../AccountEditPopup/utils';
import { NAME_MAX_LEN } from '../AccountEditPopup/constants';

const cx = classNames.bind(styles);

const getDefaultState = (props) => ({
  nickName: props.nickName || '',
  isDirty: false,
  nickNameError: '',
});

class PhoneNumberConfig extends PureComponent {
  constructor(props) {
    super(props);

    this.state = getDefaultState(props);

    this.nickNameErrorSync = '';
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.props.isMasterNickNameUpdating && !props.isMasterNickNameUpdating) {
      this.setState(getDefaultState(props));
      this.nickNameErrorSync = '';
    }
  }

  handleNickNameChange = (nextValue) => {
    const inputError = getNicknameInputError(nextValue);

    this.nickNameErrorSync = inputError;

    if (inputError) {
      this.setState({
        nickNameError: inputError,
      });
      return;
    }

    this.setState({
      nickName: nextValue,
      isDirty: true,
      nickNameError: '',
    });
  };

  handleNickNameBlur = () => {
    if (this.nickNameErrorSync) {
      this.setState({
        nickNameError: this.nickNameErrorSync,
      });
      return;
    }

    const err = validateNickname(this.state.nickName);

    this.nickNameErrorSync = err;

    this.setState({
      nickNameError: err,
    });
  };

  handleSave = () => {
    const { updateMasterNickName } = this.props;
    const { nickName, nickNameError, isDirty } = this.state;

    if (!isDirty) {
      return;
    }

    if (this.nickNameErrorSync || nickNameError) {
      return;
    }

    const err = validateNickname(nickName);
    if (err) {
      this.nickNameErrorSync = err;
      this.setState({
        nickNameError: err,
      });
      return;
    }

    const normalizedNickName = nickName === '' ? '' : normalizeName(nickName);

    updateMasterNickName(normalizedNickName);
  };

  render() {
    const { nickName, isDirty, nickNameError } = this.state;

    const {
      masterLogin,
      isMasterNickNameUpdating,
      fetchPinPuk,
      pinPukFetchingError,
      isPinPukFetching,
      pinPuk,
      location,
    } = this.props;

    const submitError = validateNickname(nickName);
    const hasAnyError = !!nickNameError || !!this.nickNameErrorSync || !!submitError;

    const isSaveDisabled = !isDirty || hasAnyError || isMasterNickNameUpdating;

    return (
      <DataBlocks.Block
        title={(
          <>
            <I18n path="settings.numberManagement.phoneNumberConfig.yourLogin" />
            &nbsp;
            {formatLogin(masterLogin)}
          </>
        )}
      >
        <div className={cx('nickNameWrapper')}>
          <I18n
            className={cx('nickNameLabel')}
            path="settings.numberManagement.phoneNumberConfig.nickNameLabel"
          />
          <TextInput
            className={cx('nickNameInput')}
            value={nickName}
            maxLength={NAME_MAX_LEN}
            autoFocus={location?.params?.activeInput === 'nickName'}
            status={nickNameError ? 'fail' : undefined}
            keepErrorIndent
            onBlur={this.handleNickNameBlur}
            onChange={this.handleNickNameChange}
          />
          <Button
            className={cx('saveButton')}
            disabled={isSaveDisabled}
            isLoading={isMasterNickNameUpdating}
            onClick={this.handleSave}
          >
            <I18n path="common.save" />
          </Button>
        </div>

        <div className={cx('footer')}>
          <PinPuk
            {...pinPuk}
            fetchPinPuk={fetchPinPuk}
            error={pinPukFetchingError}
            isLoading={isPinPukFetching}
            isLoaded={!!pinPuk}
          />
        </div>
      </DataBlocks.Block>
    );
  }
}

PhoneNumberConfig.propTypes = {
  masterLogin: PropTypes.string,
  isMasterNickNameUpdating: PropTypes.bool,
  updateMasterNickName: PropTypes.func,
  fetchPinPuk: PropTypes.func,
  pinPukFetchingError: PropTypes.string,
  isPinPukFetching: PropTypes.bool,
  pinPuk: PropTypes.object,
  location: PropTypes.object,
};

export default withRouter(PhoneNumberConfig);
